import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedMaterialModule } from './shared-material.module';
import { IconsComponent } from './icons/icons.component';
import { ShimmerDataComponent } from './shimmer-data/shimmer-data.component';

/**
 * Minimal UI for App shell (Layout). Keeps cropper / uploader / doc-viewer
 * out of the eager main graph.
 */
@NgModule({
  declarations: [IconsComponent, ShimmerDataComponent],
  imports: [CommonModule, SharedMaterialModule, NgbModule],
  exports: [
    IconsComponent,
    ShimmerDataComponent,
    SharedMaterialModule,
    NgbModule,
  ],
})
export class CoreUiSharedModule {}
